/* Sunkissed custom: "Build your set" pair on the product page (CRO build, Sep 2026).
   On a Top or Bottom product page, replaces the theme's size row with two tiles:
   this piece (its size drives the theme's own size radios) and the matching piece in the
   same colourway (own size, "Add the bottom +" button). One button then adds both.
   Match source: complementary recs -> related recs -> predictive search.
   Nothing renders (theme stays untouched) when no match is found. */
(function () {
  'use strict';
  var SET_SAVING_CENTS = 2000;   // "save $20" label; set to 0 to hide the saving text
  var SET_DEFAULT_ON = false;    // set starts off; shopper opts in with the tile button
  var page = document.querySelector('.product__page');
  if (!page) return;

  function pieceOf(t) { if (/\bone[- ]?piece\b/i.test(t)) return null; if (/\btop\b/i.test(t)) return 'top'; if (/\bbottom\b/i.test(t)) return 'bottom'; return null; }
  function colorOf(t) { var i = t.lastIndexOf(' - '); return i > -1 ? t.slice(i + 3).trim() : null; }
  function baseName(t) { return t.split(' - ')[0].trim(); }
  function money(c) { var v = c / 100; return '$' + (Math.round(v) === v ? v : v.toFixed(2)); }
  function fetchJson(u) { return fetch(u).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function imgUrl(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function currentTitle() { var t = page.querySelector('.product__title [data-zoom-caption]') || page.querySelector('.product__title'); return t ? t.textContent.trim() : ''; }
  function currentHandle() { var m = location.pathname.match(/\/products\/([a-z0-9-]+)/i); return m ? m[1] : null; }
  function productId() { var el = page.querySelector('form[action*="/cart/add"] [name="product-id"], [data-product-id]'); return el ? (el.value || el.getAttribute('data-product-id')) : null; }
  function sizeIdx(prod) { var idx = -1; (prod.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : o.name; if (/size/i.test(n || '')) idx = i; }); return idx; }

  function sizeWrapper() {
    var w = page.querySelector('.selector-wrapper--size');
    if (w) return w;
    var legends = page.querySelectorAll('.radio__legend');
    for (var i = 0; i < legends.length; i++) { var n = legends[i].querySelector('.radio__legend__option-name'); if (n && /size/i.test(n.textContent)) return legends[i].closest('.selector-wrapper') || legends[i].closest('fieldset'); }
    return null;
  }
  function sizeRadios() { var w = sizeWrapper(); return w ? Array.prototype.slice.call(w.querySelectorAll('input[type="radio"]')) : []; }
  function checkedSize() { var r = sizeRadios().filter(function (x) { return x.checked; })[0]; return r ? r.value : null; }

  function findMatch(title, pid, handle) {
    var mine = pieceOf(title);
    var want = mine === 'top' ? 'bottom' : mine === 'bottom' ? 'top' : null;
    if (!want) return Promise.resolve(null);
    var color = colorOf(title);
    var q = encodeURIComponent(want + (color ? ' ' + color : ''));
    var srcs = [
      pid ? fetchJson('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=complementary') : Promise.resolve(null),
      pid ? fetchJson('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related') : Promise.resolve(null),
      fetchJson('/search/suggest.json?q=' + q + '&resources[type]=product&resources[limit]=10')
    ];
    return Promise.all(srcs).then(function (r) {
      var all = [];
      (r[0] && r[0].products || []).forEach(function (p) { all.push(p); });
      (r[1] && r[1].products || []).forEach(function (p) { all.push(p); });
      var sr = r[2] && r[2].resources && r[2].resources.results && r[2].resources.results.products; (sr || []).forEach(function (p) { all.push(p); });
      var pick = null;
      all.forEach(function (p) {
        var t = p.title || ''; var h = p.handle || ((p.url || '').match(/\/products\/([a-z0-9-]+)/i) || [])[1];
        if (pick || !h || h === handle) return;
        if (pieceOf(t) !== want) return;
        if (color && (colorOf(t) || '').toLowerCase() !== color.toLowerCase()) return;
        pick = h;
      });
      return pick ? fetchJson('/products/' + pick + '.js') : null;
    });
  }

  var state = { main: null, match: null, on: SET_DEFAULT_ON, el: null, row: null, matchVariantId: null, matchTouched: false, passThrough: false };

  function mainVariant() {
    var input = page.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = input ? parseInt(input.value, 10) : null;
    var vs = state.main && state.main.variants || [];
    return vs.filter(function (v) { return v.id === id; })[0] || vs.filter(function (v) { return v.available; })[0] || null;
  }
  function matchVariant() {
    if (!state.match) return null;
    return (state.match.variants || []).filter(function (v) { return v.id === state.matchVariantId; })[0] || null;
  }
  function labelOf(prod, v) { var idx = sizeIdx(prod); return idx > -1 ? v['option' + (idx + 1)] : v.title; }
  function sizeSquares(prod, selectedId, attr) {
    return (prod.variants || []).map(function (v) {
      var label = labelOf(prod, v);
      return '<button type="button" class="sk-sq' + (v.id === selectedId ? ' is-selected' : '') + '" ' + attr + '="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-pressed="' + (v.id === selectedId ? 'true' : 'false') + '">' + esc(label) + '</button>';
    }).join('');
  }
  function firstAvailableMatching(label) {
    var vs = (state.match.variants || []).filter(function (v) { return v.available; });
    return vs.filter(function (v) { return labelOf(state.match, v) === label; })[0] || vs[0] || null;
  }

  function render() {
    var mine = pieceOf(state.main.title), theirs = mine === 'top' ? 'bottom' : 'top';
    var Mine = mine.charAt(0).toUpperCase() + mine.slice(1), Theirs = theirs.charAt(0).toUpperCase() + theirs.slice(1);
    var matchImg = imgUrl((state.match.featured_image || (state.match.images && state.match.images[0]) || ''), 300);
    var mainImg = imgUrl((state.main.featured_image || (state.main.images && state.main.images[0]) || ''), 300);
    var matchUrl = '/products/' + state.match.handle;
    var xv0 = firstAvailableMatching(checkedSize());
    state.matchVariantId = xv0 ? xv0.id : null;
    var w = sizeWrapper(); if (!w) return;
    var saving = SET_SAVING_CENTS > 0 ? ' · <span class="sk-switch__save">save ' + money(SET_SAVING_CENTS) + '</span>' : '';

    // 1. Switch above the size row
    var sw = document.createElement('div');
    sw.className = 'sk-switch'; sw.setAttribute('data-sk-switch', '');
    sw.innerHTML =
      '<button type="button" class="sk-switch__opt' + (state.on ? '' : ' is-on') + '" data-sk-mode="single" aria-pressed="' + (state.on ? 'false' : 'true') + '"><span class="sk-switch__label">' + Mine + ' only</span><span class="sk-switch__price" data-sk-single-price></span></button>' +
      '<button type="button" class="sk-switch__opt' + (state.on ? ' is-on' : '') + '" data-sk-mode="set" aria-pressed="' + (state.on ? 'true' : 'false') + '"><span class="sk-switch__label">Complete set</span><span class="sk-switch__price"><span data-sk-set-price></span>' + saving + '</span></button>';
    var ph = page.querySelector('[data-sk-pair-placeholder]');
    if (ph) ph.parentNode.replaceChild(sw, ph); else w.parentNode.insertBefore(sw, w);

    // 2. Matching piece row below the size row (visible only in set mode)
    var row = document.createElement('div');
    row.className = 'sk-match' + (state.on ? ' is-on' : ''); row.setAttribute('data-sk-match', '');
    row.innerHTML =
      '<a class="sk-match__thumb" href="' + matchUrl + '">' + (matchImg ? '<img src="' + matchImg + '" alt="">' : '') + '</a>' +
      '<div class="sk-match__body">' +
        '<div class="sk-match__head"><span class="sk-match__label">' + Theirs + ' · <strong data-sk-match-label>' + (xv0 ? esc(labelOf(state.match, xv0)) : '') + '</strong></span><a class="sk-match__name" href="' + matchUrl + '">' + esc(baseName(state.match.title)) + '</a></div>' +
        '<div class="sk-match__sizes" data-sk-match-sizes>' + sizeSquares(state.match, state.matchVariantId, 'data-sk-match-size') + '</div>' +
      '</div>';
    w.parentNode.insertBefore(row, w.nextSibling);
    // thumbnail beside the theme's own size row while in set mode
    w.classList.add('sk-main-size');
    var mainThumb = document.createElement('span'); mainThumb.className = 'sk-main-size__thumb'; mainThumb.setAttribute('aria-hidden', 'true');
    if (mainImg) mainThumb.innerHTML = '<img src="' + mainImg + '" alt="">';
    w.insertBefore(mainThumb, w.firstChild);

    state.el = sw; state.row = row;
    page.classList.add('sk-pair-active');
    page.classList.toggle('sk-set-on', state.on);

    document.addEventListener('click', function (e) {
      var opt = e.target && e.target.closest && e.target.closest('[data-sk-mode]'); if (!opt) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      setMode(opt.getAttribute('data-sk-mode') === 'set');
    }, true);
    // Capture-phase so the theme's own form handlers never swallow the tap
    document.addEventListener('click', function (e) {
      var sq = e.target && e.target.closest && e.target.closest('[data-sk-match-size]'); if (!sq || sq.disabled) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      state.matchTouched = true;
      state.matchVariantId = parseInt(sq.getAttribute('data-sk-match-size'), 10);
      paintMatchSizes(); refreshButton();
      document.dispatchEvent(new CustomEvent('sk:set:change', { bubbles: true, detail: { on: state.on } }));
    }, true);
    document.addEventListener('theme:variant:change', function () {
      // follow this piece's size unless the shopper already chose the other size by hand
      if (!state.matchTouched) { var v = firstAvailableMatching(checkedSize()); if (v) { state.matchVariantId = v.id; paintMatchSizes(); } }
      setTimeout(refreshButton, 40);
    });
    refreshButton();
    document.dispatchEvent(new CustomEvent('sk:set:ready', { bubbles: true }));
  }

  function setMode(on) {
    state.on = on;
    page.classList.toggle('sk-set-on', on);
    if (state.row) state.row.classList.toggle('is-on', on);
    Array.prototype.forEach.call(state.el.querySelectorAll('[data-sk-mode]'), function (o) {
      var isOn = (o.getAttribute('data-sk-mode') === 'set') === on;
      o.classList.toggle('is-on', isOn); o.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
    refreshButton();
    document.dispatchEvent(new CustomEvent('sk:set:change', { bubbles: true, detail: { on: on } }));
  }
  function paintMatchSizes() {
    if (!state.row) return;
    Array.prototype.forEach.call(state.row.querySelectorAll('[data-sk-match-size]'), function (b) {
      var sel = parseInt(b.getAttribute('data-sk-match-size'), 10) === state.matchVariantId;
      b.classList.toggle('is-selected', sel); b.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    var lab = state.row.querySelector('[data-sk-match-label]'); var xv = matchVariant();
    if (lab && xv) lab.textContent = labelOf(state.match, xv);
  }
  function paintSwitchPrices() {
    if (!state.el) return;
    var mv = mainVariant(), xv = matchVariant() || firstAvailableMatching(checkedSize());
    var s = state.el.querySelector('[data-sk-single-price]'), t = state.el.querySelector('[data-sk-set-price]');
    if (s && mv) s.textContent = money(mv.price);
    if (t && mv && xv) { var full = (mv.compare_at_price || mv.price) + (xv.compare_at_price || xv.price), price = mv.price + xv.price; t.innerHTML = (full > price ? '<s>' + money(full) + '</s> ' : '') + money(price); }
  }

  // Sunkissed (Oct 6): per-variant preorder flag from the theme's variant metafields JSON
  function isPre(v) { var m = document.querySelector('[data-variant-metafields]'); if (!v || !m) return false; try { return JSON.parse(m.textContent).some(function (x) { return Number(x.variant_id) === v.id && x.preorder === 'true'; }); } catch (e) { return false; } }
  function addButton() { return page.querySelector('form[action*="/cart/add"] [data-add-to-cart]'); }

  function refreshButton() {
    paintSwitchPrices();
    var btn = addButton(); if (!btn) return;
    var txt = btn.querySelector('[data-add-to-cart-text]'); if (!txt) return;
    var mv = mainVariant(), xv = state.on ? matchVariant() : null;
    if (!mv || !mv.available) { btn.classList.remove('sk-set-btn'); return; }
    if (!xv) {
      var single = (isPre(mv) && window.theme && window.theme.strings && window.theme.strings.preOrder) || (window.theme && window.theme.strings && window.theme.strings.addToCart) || 'Add to bag';
      var cmp = mv.compare_at_price && mv.compare_at_price > mv.price ? '<s>' + money(mv.compare_at_price) + '</s>' : '';
      txt.innerHTML = single + '<span class="btn__price" data-product-price>' + money(mv.price) + cmp + '</span>';
      btn.classList.remove('sk-set-btn');
      return;
    }
    var price = mv.price + xv.price;
    var full = (mv.compare_at_price || mv.price) + (xv.compare_at_price || xv.price);
    var was = full > price ? '<s>' + money(full) + '</s>' : '';
    txt.innerHTML = 'Add set to bag<span class="btn__price" data-product-price>' + was + money(price) + '</span>';
    btn.classList.add('sk-set-btn');
  }

  // Add flow: matching piece first (silent), then the theme adds this piece and opens the bag
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product__page form[action*="/cart/add"] [data-add-to-cart]');
    if (!btn || state.passThrough || !state.el || !state.on) return;
    var xv = matchVariant(); if (!xv) return;
    e.preventDefault(); e.stopImmediatePropagation();
    btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: xv.id, quantity: 1 }] }) })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .catch(function () {
        var box = page.querySelector('[data-cart-errors-container]');
        if (box) { box.innerHTML = '<div class="errors">The matching piece could not be added. Adding this piece only.</div>'; setTimeout(function () { box.innerHTML = ''; }, 5000); }
      })
      .then(function () {
        btn.classList.remove('is-loading');
        state.passThrough = true;
        try { btn.click(); } finally { state.passThrough = false; }
      });
  }, true);

  function placeholder() {
    var w = sizeWrapper(); if (!w || page.querySelector('[data-sk-pair-placeholder]')) return;
    if (!pieceOf(currentTitle())) return;
    var ph = document.createElement('div'); ph.className = 'sk-switch sk-switch--placeholder'; ph.setAttribute('data-sk-pair-placeholder', '');
    w.parentNode.insertBefore(ph, w);
    setTimeout(function () { if (ph.parentNode && !state.el) ph.parentNode.removeChild(ph); }, 6000);
  }

  function run() {
    if (state.el) return;
    var title = currentTitle(), handle = currentHandle();
    if (!pieceOf(title) || !handle) return;
    var optNames = Array.prototype.map.call(page.querySelectorAll('.radio__legend__option-name'), function (n) { return n.textContent.trim().toLowerCase(); });
    if (optNames.indexOf('top') > -1 && optNames.indexOf('bottom') > -1) return; // already a set product
    placeholder();
    Promise.all([fetchJson('/products/' + handle + '.js'), findMatch(title, productId(), handle)]).then(function (r) {
      if (!r[0] || !r[1]) { var ph = page.querySelector('[data-sk-pair-placeholder]'); if (ph) ph.parentNode.removeChild(ph); return; }
      state.main = r[0]; state.match = r[1];
      render();
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  window.skSetPair = {
    isOn: function () { return !!(state.el && state.on); },
    hasMatch: function () { return !!(state.el && state.match); },
    setMode: function (on) { if (state.el) setMode(!!on); },
    mainPiece: function () { var p = state.main ? pieceOf(state.main.title) : 'piece'; return p.charAt(0).toUpperCase() + p.slice(1); },
    matchPiece: function () { return state.match ? pieceOf(state.match.title) : null; },
    matchSize: function () { var xv = matchVariant(); return xv ? labelOf(state.match, xv) : null; },
    matchVariantId: function () { return state.matchVariantId; },
    matchVariants: function () { return state.match ? (state.match.variants || []).map(function (v) { return { id: v.id, label: labelOf(state.match, v), available: !!v.available }; }) : []; },
    selectMatch: function (id) { if (!state.match) return; state.matchTouched = true; state.matchVariantId = id; paintMatchSizes(); refreshButton(); document.dispatchEvent(new CustomEvent('sk:set:change', { bubbles: true, detail: { on: state.on } })); },
    singlePrice: function () { var mv = mainVariant(); return mv ? money(mv.price) : ''; },
    setPrice: function () { var mv = mainVariant(), xv = matchVariant() || firstAvailableMatching(checkedSize()); if (!mv || !xv) return ''; var full = (mv.compare_at_price || mv.price) + (xv.compare_at_price || xv.price), price = mv.price + xv.price; return (full > price ? '<s>' + money(full) + '</s> ' : '') + money(price) + (SET_SAVING_CENTS > 0 ? ' · <span class="sk-switch__save">save ' + money(SET_SAVING_CENTS) + '</span>' : ''); }
  };
})();
